import { gql } from '@grandvisionhq/graphql';
import { shoppinglistOverviewFragment } from '../fragments/shopping-list.js';

var GET_MY_WISH_LIST = gql`
  query GetMyWishlist {
    me {
      id
      wishlist {
        ...ShoppinglistOverviewFragment
      }
    }
  }
  ${shoppinglistOverviewFragment}
`;

export { GET_MY_WISH_LIST as default };
//# sourceMappingURL=get-my-wish-list.js.map
